import React from 'react';
import JobForm from '../components/JobForm';

const CreateJob = () => {
  return <JobForm isEdit={false} />;
};

export default CreateJob;
